import {
  Box,
  Button,
  IconButton,
  styled,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import RenderProduct from "../RenderProduct";
import { handleLinkToDetails } from "../../utils";
import { ShoppingCart } from "@mui/icons-material";

const AccessoryContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",

  padding: "0 8px 0 0",

  border: `1px solid ${theme.palette.grey[100]}`,
  backgroundColor: theme.palette.common.white,
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  height: "clamp(56px, calc(33px + 6.1vw), 88px)",
  width: "clamp(56px, calc(33px + 6.1vw), 88px)",
  minWidth: "clamp(56px, calc(33px + 6.1vw), 88px)",

  padding: "clamp(6px, calc(3px + 0.8vw), 10px)",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  border: `1px solid ${theme.palette.grey[100]}`,
  borderLeft: 0,

  "&:first-of-type": {
    borderTop: 0,
  },

  "&:last-of-type": {
    borderBottom: 0,
  },

  backgroundColor: theme.palette.common.white,
}));

const InfoContainer = styled(Box)(() => ({
  width: "100%",

  padding: "0 16px",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",

  gap: "4px",
}));

const CounterContainer = styled(Box)(() => ({
  paddingRight: "16px",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-end",
}));

interface SelectAccessoriesItemProps {
  id: string;
  name: string;
  quantity: number;
  imageUrl: string;
  isAdded: boolean;

  handleUpdateQuantity: (id: string, quantity: number) => void;
  handleToggleCart: (id: string) => void;
}

const SelectItem: React.FC<SelectAccessoriesItemProps> = ({
  id,
  name,
  quantity,
  imageUrl,
  isAdded,
  handleUpdateQuantity,
  handleToggleCart,
}) => {
  const isResponsive = useMediaQuery((theme: any) =>
    theme.breakpoints.down("md"),
  );
  return (
    <AccessoryContainer>
      <ImageContainer>
        <RenderProduct src={imageUrl} name={name} />
      </ImageContainer>
      <InfoContainer>
        <Typography variant="bodyMediumWeightMedium">{name}</Typography>
        <Button
          variant="text"
          sx={(theme) => ({
            padding: 0,
            color: theme.palette.primary.main,
            justifyContent: "start",
          })}
          onClick={() => handleLinkToDetails(id)}
        >
          <Typography variant="bodyMediumWeightRegular">{id}</Typography>
        </Button>
      </InfoContainer>
      {isResponsive ? (
        <IconButton
          sx={(theme) => ({
            position: "relative",
            backgroundColor: isAdded
              ? theme.palette.grey[100]
              : theme.palette.secondary.main,
            color: isAdded
              ? theme.palette.grey[600]
              : theme.palette.common.white,

            "&:hover": {
              backgroundColor: isAdded
                ? theme.palette.grey[200]
                : theme.palette.secondary.main,
            },
          })}
          onClick={() => handleToggleCart(id)}
          aria-label={isAdded ? "Remove from cart" : "Add to cart"}
        >
          <ShoppingCart />
        </IconButton>
      ) : (
        <Button
          variant="containedAbb"
          sx={(theme) => ({
            width: "170px",
            whiteSpace: "nowrap",
            ...(isAdded
              ? {
                  backgroundColor: theme.palette.grey[100],
                  color: theme.palette.grey[600],
                  "&:hover": {
                    backgroundColor: theme.palette.grey[200],
                  },
                }
              : {}),
          })}
          onClick={() => handleToggleCart(id)}
        >
          {!isAdded ? "Add to cart" : "Remove from cart"}
        </Button>
      )}
    </AccessoryContainer>
  );
};

export default SelectItem;
